// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  ControllerInfoVariant,
  unionToControllerInfoVariant,
  unionListToControllerInfoVariant,
} from "./controller-info-variant";
import {
  NormalControllerInfo,
  NormalControllerInfoT,
  verifyNormalControllerInfo,
} from "./normal-controller-info";
import {
  ValuedControllerInfo,
  ValuedControllerInfoT,
  verifyValuedControllerInfo,
} from "./valued-controller-info";

export class EscalatorControllerInfoMessage implements flatbuffers.IUnpackableObject<EscalatorControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EscalatorControllerInfoMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEscalatorControllerInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorControllerInfoMessage,
  ): EscalatorControllerInfoMessage {
    return (obj || new EscalatorControllerInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsEscalatorControllerInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: EscalatorControllerInfoMessage,
  ): EscalatorControllerInfoMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EscalatorControllerInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  infoType(): ControllerInfoVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControllerInfoVariant.NONE;
  }

  info<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startEscalatorControllerInfoMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addInfoType(builder: flatbuffers.Builder, infoType: ControllerInfoVariant) {
    builder.addFieldInt8(0, infoType, ControllerInfoVariant.NONE);
  }

  static addInfo(builder: flatbuffers.Builder, infoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, infoOffset, 0);
  }

  static endEscalatorControllerInfoMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // info
    return offset;
  }

  static createEscalatorControllerInfoMessage(
    builder: flatbuffers.Builder,
    infoType: ControllerInfoVariant,
    infoOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EscalatorControllerInfoMessage.startEscalatorControllerInfoMessage(builder);
    EscalatorControllerInfoMessage.addInfoType(builder, infoType);
    EscalatorControllerInfoMessage.addInfo(builder, infoOffset);
    return EscalatorControllerInfoMessage.endEscalatorControllerInfoMessage(builder);
  }

  unpack(): EscalatorControllerInfoMessageT {
    return new EscalatorControllerInfoMessageT(
      this.infoType(),
      (() => {
        const temp = unionToControllerInfoVariant(this.infoType(), this.info.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: EscalatorControllerInfoMessageT): void {
    _o.infoType = this.infoType();
    _o.info = (() => {
      const temp = unionToControllerInfoVariant(this.infoType(), this.info.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): EscalatorControllerInfoMessageT {
    const t = new EscalatorControllerInfoMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("info_type")) {
      t.infoType = this.infoType();
    }
    if (fieldSet.has("info")) {
      t.info = (() => {
        const temp = unionToControllerInfoVariant(this.infoType(), this.info.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class EscalatorControllerInfoMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public infoType: ControllerInfoVariant = ControllerInfoVariant.NONE,
    public info: NormalControllerInfoT | ValuedControllerInfoT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.info === null || this.info === undefined) {
      throw new Error('Required field "info" is not set');
    }
    const info = builder.createObjectOffset(this.info);

    return EscalatorControllerInfoMessage.createEscalatorControllerInfoMessage(
      builder,
      this.infoType,
      info,
    );
  }

  clone(): EscalatorControllerInfoMessageT {
    const obj = new EscalatorControllerInfoMessageT();
    obj.infoType = this.infoType;
    obj.info =
      this.info !== null && typeof (this.info as any).clone === "function"
        ? (this.info as any).clone()
        : this.info;
    return obj;
  }

  equals(other: EscalatorControllerInfoMessageT): boolean {
    if (this.infoType !== other.infoType) return false;
    if (this.info !== null && other.info !== null) {
      if (typeof (this.info as any).equals === "function") {
        if (!(this.info as any).equals(other.info)) return false;
      } else if (this.info !== other.info) return false;
    } else if (this.info !== other.info) return false;
    return true;
  }
}

export function verifyEscalatorControllerInfoMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "info");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalControllerInfo
            {
              const o = verifier.readInt32(pos);
              verifyNormalControllerInfo(verifier, pos + o);
            }
            break;
          case 2: // ValuedControllerInfo
            {
              const o = verifier.readInt32(pos);
              verifyValuedControllerInfo(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "info");
  } finally {
    verifier.popDepth();
  }
}
